import { Grid } from '@material-ui/core';
import {
  EntityApiDefinitionCard,
  EntityConsumedApisCard,
  EntityConsumingComponentsCard,
  EntityHasApisCard,
  EntityProvidedApisCard,
  EntityProvidingComponentsCard,
} from '@backstage/plugin-api-docs';
import { EntityLayout, EntitySwitch, isKind } from '@backstage/plugin-catalog';
import {
  EntityGroupProfileCard,
  EntityMembersListCard,
  EntityOwnershipCard,
  EntityUserProfileCard,
} from '@backstage/plugin-org';
import { RELATION_HAS_PART } from '@backstage/catalog-model';
import { EntitySonarQubeCard, SonarQubeRelatedEntitiesOverview } from '@backstage-community/plugin-sonarqube';
import { entityWarningContent } from './EntityWarningContent.tsx';
import { EntityOverviewContent } from './EntityOverviewContent.tsx';
import { EntityDependencytrackFindingCard, isDependencytrackAvailable } from '@trimm/plugin-dependencytrack';
import { entityRepositoryContent } from './EntityRepositoryContent.tsx';
import { EntityRenovateContent } from '@secustor/backstage-plugin-renovate';
import { EntityTechdocsContent } from '@backstage/plugin-techdocs';
import { TechDocsAddons } from '@backstage/plugin-techdocs-react';
import { LightBox, ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';

const defaultEntityPage = (
  <EntityLayout.Route path="/" title="Overview">
    <EntityOverviewContent />
  </EntityLayout.Route>
);

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('domain')}>
      <EntityLayout>
        {defaultEntityPage}
        <EntityLayout.Route path="/definition" title="Definition">
          <EntityTechdocsContent>
            <TechDocsAddons>
              <LightBox />
              <ReportIssue />
            </TechDocsAddons>
          </EntityTechdocsContent>
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('system')}>
      <EntityLayout>
        {defaultEntityPage}
        <EntityLayout.Route path="/api" title="API">
          <Grid container>
            <Grid item xs={12}>
              <EntityHasApisCard />
            </Grid>
          </Grid>
        </EntityLayout.Route>
        <EntityLayout.Route path="/repository" title="Repository">
          {entityRepositoryContent}
        </EntityLayout.Route>
        <EntityLayout.Route path="/insights" title="Insights">
          <Grid container>
            <Grid item xs={12}>
              <SonarQubeRelatedEntitiesOverview
                relationType={RELATION_HAS_PART}
                entityKind="component"
              />
            </Grid>
          </Grid>
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('component')}>
      <EntityLayout>
        {defaultEntityPage}
        <EntityLayout.Route path="/api" title="API">
          <Grid container>
            <Grid item xs={12}>
              <EntityProvidedApisCard />
            </Grid>
            <Grid item xs={12}>
              <EntityConsumedApisCard />
            </Grid>
          </Grid>
        </EntityLayout.Route>
        <EntityLayout.Route path="/repository" title="Repository">
          {entityRepositoryContent}
        </EntityLayout.Route>
        <EntityLayout.Route path="/insights" title="Insights">
          <Grid container>
            <Grid item xs={12}>
              <EntitySonarQubeCard
                variant="gridItem"
                missingAnnotationReadMoreUrl="/docs/default/system/console/3-tutorials/#show-sonarqube-results-in-catalog"
              />
            </Grid>
            <EntitySwitch>
              <EntitySwitch.Case if={isDependencytrackAvailable}>
                <Grid item xs={12}>
                  <EntityDependencytrackFindingCard />
                </Grid>
              </EntitySwitch.Case>
            </EntitySwitch>
          </Grid>
        </EntityLayout.Route>
        <EntityLayout.Route path="/dependencies" title="Dependencies">
          <Grid container>
            <Grid item xs={12}>
              <EntityRenovateContent />
            </Grid>
          </Grid>
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('api')}>
      <EntityLayout>
        {defaultEntityPage}
        <EntityLayout.Route path="/api" title="API">
          <Grid container>
            <Grid item xs={12}>
              <EntityProvidingComponentsCard />
            </Grid>
            <Grid item xs={12}>
              <EntityConsumingComponentsCard />
            </Grid>
          </Grid>
        </EntityLayout.Route>
        <EntityLayout.Route path="/definition" title="Definition">
          <EntityApiDefinitionCard />
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('group')}>
      <EntityLayout>
        <EntityLayout.Route path="/" title="Overview">
          <Grid container>
            {entityWarningContent}
            <Grid item md={6} xs={12}>
              <EntityGroupProfileCard />
            </Grid>
            <Grid item md={6} xs={12}>
              <EntityOwnershipCard />
            </Grid>
            <Grid item xs={12}>
              <EntityMembersListCard />
            </Grid>
          </Grid>
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('user')}>
      <EntityLayout>
        <EntityLayout.Route path="/" title="Overview">
          <Grid container>
            {entityWarningContent}
            <Grid item md={6} xs={12}>
              <EntityUserProfileCard />
            </Grid>
            <Grid item md={6} xs={12}>
              <EntityOwnershipCard />
            </Grid>
          </Grid>
        </EntityLayout.Route>
      </EntityLayout>
    </EntitySwitch.Case>
    <EntitySwitch.Case>
      <EntityLayout>{defaultEntityPage}</EntityLayout>
    </EntitySwitch.Case>
  </EntitySwitch>
);
